import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AssignLeadsInput } from '../../../shared/models/lead/assignLeads.input';
import { UnAssignLeadsInput } from '../../../shared/models/lead/unAssignLeads.input';
import { RolType } from '../../../shared/models/types/rol.types';
import { CompanyService } from '../../../shared/services/company/company.service';
import { LeadService } from '../../../shared/services/lead/lead.service';
import { AuthService } from '../../../shared/services/security/auth.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-assign-modal',
  templateUrl: './assign-modal.component.html',
  styleUrls: []
})
export class AssignModalComponent implements OnInit, OnDestroy {

  @ViewChild('content', { static: false }) content: Element;
  closeResult: string;
  idLeads: string[];
  sending = false;
  isRequiredComment: boolean;
  comment: string;
  rolType: RolType = new RolType();
  assigmentMethodType: string;
  unAssignLeadSubcription: Subscription;
  showComment: boolean;

  static getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    }
    if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    }

    return `with: ${reason}`;
  }

  constructor(
    private readonly modalsHandler: ModalsHandlerService,
    private readonly leadComunicationService: LeadsComunicationService,
    private readonly modalService: NgbModal,
    private readonly leadService: LeadService,
    private readonly toastService: ToastService,
    private readonly authService: AuthService,
    private readonly companyService: CompanyService,

  ) {
  }

  ngOnInit(): void {
    this.unAssignLeadSubcription = this.leadComunicationService.unAssignLead.subscribe(data => {
      this.unAssignLead(data);
    });

    this.modalsHandler.assignModal.subscribe(data => {
      this.open(this.content);
      this.idLeads = data.ids;
      this.isRequiredComment = this.authService.getUserRol() === this.rolType.ROLE_USER;
      this.showComment = data.showComment;
      this.comment = null;

      this.companyService.getAssigmentMethod$().subscribe((assigmentMethod: string) => {
        this.assigmentMethodType = assigmentMethod;
      });
    });

  }

  ngOnDestroy() {
    this.unAssignLeadSubcription.unsubscribe();
  }

  open(content: any): void {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static', keyboard: false
    }).result.then(() => undefined, reason => {
      this.closeResult = `Dismissed ${AssignModalComponent.getDismissReason(reason)}`;
    });
  }

  assignLeads(userDropDownComponent: any): void {
    const assignInput = new AssignLeadsInput();
    assignInput.leadIds = this.idLeads;
    assignInput.userId = userDropDownComponent.selectedItems[0].id;
    assignInput.comments = this.comment;
    if (this.assigmentMethodType === 'prequalification' && !this.isRequiredComment && !assignInput.userId) {
      const unAssignInput = new UnAssignLeadsInput();
      unAssignInput.leadIds = this.idLeads;
      unAssignInput.comments = this.comment;
      this.unAssignLead(assignInput);
    } else {
      this.leadService.assignLeads$(assignInput).subscribe(() => {
        this.successToastAndResponse();
      }, () => {
        this.failToastAndResponse();
      });
    }
    this.modalService.dismissAll();
  }

  private unAssignLead(assignInput: AssignLeadsInput) {
    this.leadService.unAssignLeads$(assignInput).subscribe(() => {
      this.successToastAndResponse();
    }, () => {
      this.failToastAndResponse();
    });
  }

  private failToastAndResponse() {
    this.toastService
      .showToast(
        'error',
        'toaster.lead.assigned.error',
        'toaster.lead.assigned.error.body'
      );
    this.sending = false;
  }

  private successToastAndResponse() {
    this.sending = true;
    this.toastService
      .showToast(
        'success',
        'toaster.lead.assigned_success',
        'toaster.lead.assigned_sucess_body'
      );
    this.sending = false;
    this.leadComunicationService.launchReloadLeads();
    this.leadComunicationService.launchReloadMyLead();
  }
}
